import { URLS } from 'api/constants';
import { IBigWins } from 'constants/types';
import { apiGet, apiGetSafe } from './client';
import { PaginationRequest, PaginationResponse } from './types';

type ApiParams = Record<string, string | number | boolean | undefined | null>;

export async function getBigWinById(id?: string) {
  return apiGetSafe<IBigWins>(`${URLS.BIGWINS_BY_ID}${id ?? ''}`);
}

export async function listBigWins(
  params: PaginationRequest & { slot?: string | null } = {}
) {
  return apiGet<PaginationResponse<IBigWins>>(
    URLS.BIGWINS,
    params as ApiParams
  );
}

export async function listBigWinsByCasino(id?: string) {
  return apiGet<PaginationResponse<IBigWins>>(
    `${URLS.BIGWINS_BY_CASINO}${id ?? ''}`
  );
}

export async function listBigWinsBySlot(id?: string) {
  return apiGet<PaginationResponse<IBigWins>>(
    `${URLS.BIGWINS_BY_SLOT}${id ?? ''}`
  );
}
